import { PlusOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import React, { FunctionComponent, useCallback, useMemo } from 'react'

import { useToggleState } from '../../utils/useToggleState'
import { AddNewLabel } from '../AddNewLabel/AddNewLabel'

export interface AddNewLabelModalButtonProps {
  refetch?: () => void
  onClick?: () => void
  isSelectBox?: boolean
}

export const AddNewLabelModalButton: FunctionComponent<AddNewLabelModalButtonProps> =
  props => {
    const [open, toggleOpen] = useToggleState()

    const handleAddLabel = useCallback(() => {
      toggleOpen()
      props.refetch?.()
    }, [props, toggleOpen])

    const handleOnClick = useCallback(() => {
      toggleOpen()
      props.onClick?.()
    }, [props, toggleOpen])

    const triggerButton = useMemo(
      () =>
        props.isSelectBox ? (
          <Button type="link" onClick={handleOnClick} className="w-full pb-2">
            <PlusOutlined /> Vytvořit nový štítek
          </Button>
        ) : (
          <Button type="primary" onClick={toggleOpen}>
            Vytvořit nový štítek
          </Button>
        ),
      [handleOnClick, props.isSelectBox, toggleOpen]
    )

    return (
      <>
        {triggerButton}

        <Modal
          title="Vytvořit nový štítek"
          open={open}
          onCancel={toggleOpen}
          footer={false}
          width={600}
        >
          <AddNewLabel refetch={handleAddLabel} />
        </Modal>
      </>
    )
  }
